import { Component, OnInit ,ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { CountryModel } from 'src/app/masters/country/country.model';
import { MasterService } from 'src/app/masters/master.service';
import { OrganismModel } from '../organisms/organism.model';
import { PartnersService } from '../partners.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import * as CommonConstants from '../../utils/common.constants';
import { AddInsuranceComponent } from './add-insurance/add-insurance.component';
import { PartnerSearchComponent } from '../partner-search/partner-search.component';
import { LoaderService } from 'src/app/common/loader.service';
import { SharedService } from 'src/app/utils/shared.service';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss']
})
export class InsuranceComponent implements OnInit {
  organisms: OrganismModel[];
  townList: any = [];
  countryList: any = [];
  columnDefs: any[];
  addInsurance;
  startIndex;
  rowsPerPage;
  totalRecords;
  paginationSize = CommonConstants.PAGINATION_SIZE;
  insuranceSearchForm: FormGroup;
  rowData: any[];
  toggleColumn = true;
  @ViewChild(PartnerSearchComponent,{static:true})   pSearch : PartnerSearchComponent;
  addressTypeList : any[];
  
  newInsurance: AddInsuranceComponent;
  priv_addInsu: any;
  @ViewChild(AddInsuranceComponent, { static: true }) set Content(newInsuranceRef) {
    this.newInsurance = newInsuranceRef;
  }
  constructor(public router: Router,private partnerService:PartnersService,private formBuilder: FormBuilder,
    private masterService: MasterService, private loaderService: LoaderService,private sharedService:SharedService) { 
    this.columnDefs = [
      // { headerName: 'Id', field: 'insurId', width: 75 },
      { headerName: 'Name', field: 'compaVaNameEn' },
      { headerName: 'Organism', field: 'orgName'},
      { headerName: 'Work Phone', field: 'compaVaWorkPhone'},
      { headerName: 'Mobile Phone', field: 'compaVaMobilePhone1'},
      { headerName: 'Email', field: 'compaVaEmail' }       
    ];
    this.getFromGroup();  
  }

  ngOnInit() {
    this.priv_addInsu=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_INSURANCE);
    this.pSearch.pSearch["active"]=true;
    this.pSearch.partnerType=CommonConstants.PARTNER_INSURANCE_TYPE;
  }
  addNewInsurance() {
    this.router.navigate(['addInsurance']);
    this.newInsurance.addInsuranceTitle = true;
    this.newInsurance.editInsuranceTitle = false;
  }
  hideRightDiv() {
    this.addInsurance = false;
    this.toggleColumn = true;
  }
/**
    * Declare form group
    *  
    */
   private getFromGroup() {
    this.insuranceSearchForm = this.formBuilder.group({
      'orgsmId':  new FormControl(),
      'name': new FormControl(),
      'cotryId': new FormControl(),
      'townId' : new FormControl()
    })
    this.loadMasterData();
  }
  loadMasterData() {
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.townList = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countryList = response['result'];
      }
    });
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
      this.searchInsurance();
    })
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });

  }
  searchInsurance() {
    //this.addLogistics = false;
    this.startIndex = 0;
    this.rowsPerPage = CommonConstants.PAGINATION_SIZE;
    //this.paginatedList();
    this.pSearch.pSearch['partnerType'] = 2;
    this.pSearch.pSearch['active']=this.pSearch.pSearch['active'] ? 'A' :'I';
    this.loaderService.display(true);
      this.partnerService.searchInsurance(this.pSearch.pSearch, this.startIndex).subscribe(response => {
        this.loaderService.display(false);
        response['result']=response['result'].map(item => ({...item,
          orgName: item.orgsmId ? this.organisms.find(obj => obj.orgsmId === item.orgsmId).compaVaNameEn : null }))
          this.rowData = response['result'];
      },
      error => {
        this.loaderService.display(false);
      })
    this.hideRightDiv();
  }

  reset(){
    this.insuranceSearchForm.reset();
    this.rowData =[];
    this.pSearch.pSearch={};
    this.hideRightDiv();
  }
 
  loadInsuranceById(event: any) {
    let insurance={
      "id":event.data.insurId
    }
    this.loaderService.display(true);
    this.partnerService.searchInsurance(insurance, this.startIndex).subscribe(response => {
      this.loaderService.display(false);
      this.newInsurance.hospDepartment.departmentList = [];
      this.newInsurance.hospAddress.addressList = [];
      this.newInsurance.hospContact.contactList=[];
      if (response['code'] == 'S0000') {
        let result = response['result'][0];
        this.newInsurance.insuranceForm.patchValue({
          insurId:result["insurId"],
      orgsmId:result["orgsmId"],
      compaVaNameEn:result["compaVaNameEn"],
      pacatId:result["pacatId"],
      pctypId:result["pctypId"],
      compaVaWorkPhone:result["compaVaWorkPhone"],
      compaVaWorkFax:result["compaVaWorkFax"],
      compaVaMobilePhone1:result["compaVaMobilePhone1"],
      compaVaMobilePhone2:result["compaVaMobilePhone2"],
      compaVaEmail:result["compaVaEmail"],
      compaVaHomepage:result["compaVaHomepage"],
      leforId:result["leforId"],
      compaNuNumberEmployees:result["compaNuNumberEmployees"],
      agmntId:result["agmntId"],
      certiId:result["certiId"],
      pagrpId:result["pagrpId"],
      staRecCode: result["staRecCode"] ==='A' ? true : false
        });

        result['addressList'] = result.addressList.map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description : null,
          townName: item.townId ? this.townList.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countryList.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        })); 
         this.newInsurance.hospDepartment.departmentList = JSON.parse(JSON.stringify(result['departmentList']));
         this.sharedService.setOrganismDepartment(this.newInsurance.hospDepartment.departmentList);
        this.newInsurance.hospAddress.addressList = JSON.parse(JSON.stringify(result['addressList']));
        this.newInsurance.hospContact.employeeList = JSON.parse(JSON.stringify(result['employeeList']));
        this.newInsurance.phoneNos.forEach(phone => {
          phone.phone=phone.getInternationPhoneFormat(result[phone.type]);
      })
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  onRowClicked(event: any) {
    this.addInsurance = true;
    this.toggleColumn = false;
    this.newInsurance.addInsuranceTitle = true;
    this.newInsurance.editInsuranceTitle = false;
     this.loadInsuranceById(event);
   }
}
